const productAccordionBlocks = document.querySelectorAll(".product-accordion-block");

productAccordionBlocks.forEach(block => {
	const tabButtons: null | NodeListOf<HTMLButtonElement> = block.querySelectorAll(".js-tab-button");
	const tabs:null | NodeListOf<HTMLElement> = block.querySelectorAll(".tabs .js-tab");

    function makeActive(nodeList, index) {
        nodeList.forEach((button) => {
			if (button.dataset.tabId == index) {
				button.classList.add("active");
			} else {
				button.classList.remove("active");
			}
		});
    }

	tabButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			const activeButton: HTMLElement = e.target as HTMLElement;
			const index = activeButton.dataset.tabId;

			makeActive(tabButtons, index)

			makeActive(tabs, index)
		});
	});
	if (tabButtons[0]) {
		const button = tabButtons[0] as HTMLButtonElement;
		button.click();
	}
})
